module.exports = __webpack_public_path__ + "6d64396c6db1460e645fd37dd81c31da.svg";